import emitter from "@/utils/emitter";
import { Toast } from "vant";
// 允许多个 Toast
Toast.allowMultiple();

let socket = null;
let userId = "";

export default (userInfo) => {
  // 不同userId或者页面刷新才会重新连接
  if (userInfo && userInfo.userId && userInfo.userId !== userId) {
    if (socket) {
      socket.close();
    }
    userId = userInfo.userId;
    const url = process.env.VUE_APP_WEBSOCKET;
    socket = new WebSocket(`${url}/webSocket/${userInfo.userId}`);

    // 接收服务端推送过来的消息
    socket.onmessage = function (evt) {
      const received_msg = evt.data;

      // 如果有json数据
      if (received_msg.startsWith("{") && received_msg.endsWith("}")) {
        try {
          const result = JSON.parse(received_msg);
          const { description, point, type } = result;
          // 每日累计学习时长
          if (type === "4000") {
            // 暴露事件 去指定页面自定义处理
            emitter.emit("video_view", result);
          } else if (type === "6100") {
            // 直接弹框提示
            Toast({
              duration: 3000,
              // position: "bottom",
              message: description + "+" + point + "积分",
            });
          } else {
            // 直接弹框提示
            Toast({
              duration: 3000,
              position: "top",
              message: description + "+" + point + "积分",
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    };

    // 发生错误时调用
    socket.onerror = function (err) {
      console.error("websocket error", err);
      socket = null;
      userId = "";
    };
    // 关闭时调用
    socket.onclose = function () {
      console.log("websocket close");
      socket = null;
      userId = "";
    };
  }
};
